/**
 * @func 通用配置构造
 * @author zhangfs by Atom
 * @param 2019/01/30 12:10
 */

const HttpError = {
  400: '请求错误',
  401: '未授权，请登录',
  403: '拒绝访问',
  404: '求地址出错',
  408: '请求超时',
  500: '服务器开个小差，请稍后再试',
  501: '服务器开个小差，请稍后再试',
  502: '服务器开个小差，请稍后再试',
  503: '服务器开个小差，请稍后再试',
  504: '服务器开个小差，请稍后再试',
  505: 'HTTP版本不受支持'
}

const Notify = {
  error: {
    title: '错误',
    message: '请求失败，请联系管理员',
    type: 'error'
  },
  warn: {
    title: '警告',
    message: '请检查您的操作是否合理',
    type: 'warning'
  },
  succes: {
    title: '成功',
    message: '操作成功',
    type: 'success'
  }
}

export { HttpError, Notify }



// WEBPACK FOOTER //
// ./src/config/index.js